import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

const IMPACT_LABELS = {
    children_supported: "Children Supported",
    women_empowered: "Women Empowered",
    villages_covered: "Villages Covered",
    digital_literacy_students: "Digital Literacy Students",
    community_programmes: "Community Programmes Conducted",
    volunteers_engaged: "Volunteers Engaged",
    partner_organisations: "Partner Organisations",
    years_of_service: "Years of Service",
};

function fmt(n) {
    if (!n && n !== 0) return "—";
    if (n >= 1000) return `${(n / 1000).toFixed(n % 1000 === 0 ? 0 : 1).replace(/\.0$/, "")}K+`;
    return `${n}+`;
}

export default function Impact() {
    const [impact, setImpact] = useState({});
    useEffect(() => { api.get("/impact-stats").then((r) => setImpact(r.data || {})); }, []);

    return (
        <div data-testid="impact-page">
            <section className="pt-20 pb-12 md:pt-32 md:pb-16">
                <div className="container-hero grid md:grid-cols-12 gap-10">
                    <div className="md:col-span-7">
                        <div className="label-eyebrow text-brand-forest mb-4">Our Impact</div>
                        <h1 className="font-display text-5xl sm:text-6xl font-semibold leading-[1.05]">Every number here is a family, a child, a village.</h1>
                    </div>
                    <div className="md:col-span-5 text-slate-600 text-lg leading-relaxed">
                        {impact.intro_text}
                    </div>
                </div>
            </section>
            <section className="pb-24 md:pb-32">
                <div className="container-hero grid grid-cols-2 md:grid-cols-4 gap-x-4 gap-y-12">
                    {Object.entries(IMPACT_LABELS).map(([k, label]) => (
                        <div key={k} data-testid={`impact-page-${k}`} className="border-t border-black/10 pt-6">
                            <div className="font-display text-5xl sm:text-6xl font-semibold text-brand-forest">{fmt(impact[k])}</div>
                            <div className="text-xs uppercase tracking-[0.15em] text-slate-500 mt-3 font-semibold">{label}</div>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
}
